var map = {
	"./example.svg": "MMMJ",
	"./hamburger.svg": "vWoH",
	"./icon-audio.svg": "rf6w",
	"./icon-main-tax-disc.svg": "xWD/",
	"./icon-rests-tax-disc.svg": "yNa1",
	"./login-icon-user.svg": "buO4",
	"./logo-gray.svg": "7wl9",
	"./logo-small.svg": "osew",
	"./logo.svg": "u2l4",
	"./logout.svg": "AXUd",
	"./menu-device-highlight.svg": "ij6Y",
	"./menu-device.svg": "IWlG",
	"./menu-group-highlight.svg": "Oj7s",
	"./menu-group.svg": "U8dP",
	"./menu-home-highlight.svg": "kKfb",
	"./menu-home.svg": "FyTA",
	"./menu-invoice-highlight.svg": "qMLz",
	"./menu-invoice.svg": "LWXs",
	"./menu-stat-highlight.svg": "qWsR",
	"./menu-stat.svg": "J6u5",
	"./menu-system-highlight.svg": "whhO",
	"./menu-system.svg": "TKSR",
	"./person.svg": "pFBE",
	"./refresh.svg": "uMRt",
	"./store.svg": "RDu0",
	"./success.svg": "qM/a",
	"./yunpiaoer.svg": "w5s6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";